<template>
  <div class="ui-component-loader">
    <ui-loader />
  </div>
</template>

<script>
import UiLoader from './ui-loader.vue'
export default {
  components: { UiLoader }
}
</script>

<style>
.ui-component-loader {
  position: relative;
  width: 100%;
  height: 250px;
}
</style>
